import useGetCatalogueData from "./useGetCatalogueData/useGetCatalogueData";
import useGetConfig from "./useGetConfig";
import useGetSession from "./useGetSession";

const ApiHandler = (): null => {
	useGetConfig();
	useGetSession();
	useGetCatalogueData();

	return null;
};

export default ApiHandler;
